import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastController: ToastController) { }

  async presentToast(message: string, duration: number, color: string, icon: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: duration,
      color: color,
      icon: icon
    });
    toast.present();
  }

  async dismissToast() {
    this.toastController.dismiss();
  }
}
